export const ZODIAC = 'zodiac';
export const PALM = 'palm';
export const TAROT = 'tarot';
export const COMPATIBILITY = 'compatibility';
